import { UIRouterModule } from "@uirouter/angular";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AssigneesModule } from "@webapp/assignees/assignees.module";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { UiButtonModule } from "@webapp/ui/button/button.module";
import { UiIconModule } from "@webapp/ui/icon/icon.module";
import { UiInputModule } from "@webapp/ui/input/input.module";
import { UiTooltipModule } from "@webapp/ui/tooltip/tooltip.module";
import { OkrViewsCopyLinkFormComponent } from "./components/okr-views-copy-link-form/okr-views-copy-link-form/okr-views-copy-link-form.component";
import { OkrViewsGridAccessCellComponent } from "./components/okr-views-grid/okr-views-grid-access-cell/okr-views-grid-access-cell.component";
import { OkrViewsGridCellComponent } from "./components/okr-views-grid/okr-views-grid-cell/okr-views-grid-cell.component";

@NgModule({
  imports: [LocalizationModule, UiIconModule, CommonModule, UiTooltipModule, AssigneesModule, UIRouterModule, UiInputModule, UiButtonModule, UiIconModule, FormsModule],
  declarations: [OkrViewsGridAccessCellComponent, OkrViewsGridCellComponent, OkrViewsCopyLinkFormComponent],
  exports: [OkrViewsGridAccessCellComponent, OkrViewsGridCellComponent, OkrViewsCopyLinkFormComponent],
})
export class OkrViewsModule {}
